import { RepairFacility } from "../models/repair-facility";

// Provides mapping methods for repair facilities.
export class RepairFacilityMapper {
	// Maps a repair facility API response to a {@link RepairFacility}.
	public static mapUserRepairFacility(repairFacilityResponse: any) {
		const rf: RepairFacility = new RepairFacility();

		rf.id = repairFacilityResponse.id;
		rf.facilityName = repairFacilityResponse.name;
		rf.emailAddress = repairFacilityResponse.email;
		rf.phone = repairFacilityResponse.phone;
		rf.preferredPaymentMethod = repairFacilityResponse.preferredPaymentMethod;
		rf.partTaxRate = repairFacilityResponse.partTaxRate;
		rf.laborTaxRate = repairFacilityResponse.laborTaxRate;
		rf.laborRate = repairFacilityResponse.laborRate;
		rf.laborManual = repairFacilityResponse.laborManual;
		rf.address.addressLine1 = repairFacilityResponse.addressLine1;
		rf.address.addressLine2 = repairFacilityResponse.addressLine2;
		rf.address.city = repairFacilityResponse.city;
		rf.address.state = repairFacilityResponse.state;
		rf.address.zip = repairFacilityResponse.zip;
		rf.address.country = repairFacilityResponse.country;

		return rf;
	}
}